import request from '@/utils/request'

// 查询
export function getCenterDataByAdmin (data) {
  return request.get('/system/dataCenter/admin/info',data)
}